import { createFileRoute, redirect } from '@tanstack/react-router'

import { movedToConsole } from '@/features/auth/require-session'

/** A listing's old address: the console's for the operator, the evaluations for anyone else. */
export const Route = createFileRoute('/_app/market/$listingId')({
  beforeLoad: ({ context, params }) =>
    movedToConsole(context.queryClient, () =>
      redirect({ to: '/platform/market/$listingId', params, replace: true }),
    ),
})
